import { Card, CardContent } from "@/components/ui/card";

const getScoreColor = (score) => {
  if (score >= 80) return 'text-green-400';
  if (score >= 60) return 'text-yellow-400';
  if (score >= 40) return 'text-orange-400';
  return 'text-red-400';
};

const getGlowColor = (score) => {
  if (score >= 80) return 'rgba(34,197,94,0.15)';
  if (score >= 60) return 'rgba(234,179,8,0.15)';
  if (score >= 40) return 'rgba(249,115,22,0.15)';
  return 'rgba(239,68,68,0.15)';
};

export const ScoreCard = ({ label, score, icon: Icon, testId }) => (
  <Card className="bg-[#121212] border-white/10 score-card" data-testid={testId}
    style={{ boxShadow: `inset 0 -2px 20px ${getGlowColor(score)}` }}>
    <CardContent className="p-5">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs text-zinc-400 uppercase tracking-widest font-semibold">{label}</span>
        {Icon && <Icon className="w-4 h-4 text-zinc-500" />}
      </div>
      <div className={`text-4xl font-mono-data font-bold ${getScoreColor(score)}`}>{score}</div>
      <div className="text-[10px] text-zinc-600 mt-1 uppercase tracking-widest">out of 100</div>
    </CardContent>
  </Card>
);

export const GradeBadge = ({ grade }) => {
  const colors = {
    A: 'bg-green-500/15 text-green-400 border-green-500/30',
    B: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
    C: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30',
    D: 'bg-orange-500/15 text-orange-400 border-orange-500/30',
    F: 'bg-red-500/15 text-red-400 border-red-500/30',
  };
  return (
    <span data-testid="grade-badge"
      className={`inline-flex items-center justify-center w-12 h-12 rounded-sm border text-2xl font-heading font-black ${colors[grade] || colors.F}`}>
      {grade}
    </span>
  );
};
